import axios from "axios";

export default function getReceiveTransferDetail(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/prife/receive-transfer/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
